import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import shapeImg1 from "../../assets/img/contact/ct-shape-1.png";
import shapeImg2 from "../../assets/img/contact/ct-shape-2.png";
import shapeImg3 from "../../assets/img/contact/ct-shape-3.png";
import shapeImg4 from "../../assets/img/contact/ct-shape-4.png";

const ContactTwo = (props) => {
  const { itemClass } = props;
  const formRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs
      .sendForm("service_3431p3x", "template_dxhelea", formRef.current, {
        publicKey: "_62BCEWsC7ngmLsrI",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert(
            "Message sent successfully! I will get back to you within 2-4 hours."
          );
          formRef.current.reset(); // Clear the form
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert(
            "Failed to send message. Please try again or contact me directly."
          );
        }
      )
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div
      className={
        itemClass
          ? itemClass
          : "contact__area contact__plr-2 mt-100 mb-100 p-relative fix"
      }
    >
      <div className="contact__shape-1 d-none d-lg-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="contact__shape-2 d-none d-md-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="contact__shape-3 d-none d-md-block">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="contact__shape-4 d-none d-md-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="contact__border">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-7">
              <div className="contact__section-title pb-10">
                <h4 className="section-subtitle char-anim">
                  Let's Collaborate
                </h4>
                <h3 className="section-title char-anim">
                  Ready to Start Your <br />
                  Next Business Project?
                </h3>
              </div>
              <div className="contact__text">
                <p className="char-anim-2">
                  I specialize in creating custom React and React Native
                  solutions for businesses. Whether you need an inventory
                  management system, employee tracking app, or analytics
                  dashboard, let's discuss how I can help streamline your
                  operations.
                </p>
              </div>
              <div
                className="contact__form wow animate__fadeInUp"
                data-wow-duration="1.1s"
              >
                <form ref={formRef} onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input
                          type="text"
                          name="user_name"
                          placeholder="Your Name *"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input
                          type="email"
                          name="user_email"
                          placeholder="Your Email *"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="postbox__contact-input">
                        <input
                          type="text"
                          name="company_name"
                          placeholder="Company Name (Optional)"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="postbox__contact-textarea">
                        <textarea
                          name="message"
                          placeholder="Tell me about your project requirements, current business challenges, and how I can help improve your operations..."
                          rows="5"
                          required
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div
                    className="contact__button wow animate__fadeInUp"
                    data-wow-duration="1.1s"
                  >
                    <a
                      className="main-btn-sm  tp-btn-hover alt-color"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(e);
                      }}
                    >
                      <span>Send Message</span>
                      <b></b>
                    </a>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-xl-4 col-lg-5">
              <div className="contact__left-side">
                <div
                  className="contact__item d-flex align-items-center wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <div className="contact__icon">
                    <span>
                      <a href="tel:+918802487352">
                        <i className="fal fa-phone-alt"></i>
                      </a>
                    </span>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm">Call or WhatsApp</h4>
                    <span>
                      <a href="tel:+918802487352">+91 8802487352</a>
                    </span>
                  </div>
                </div>
                <div
                  className="contact__item d-flex align-items-center wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <div className="contact__icon">
                    <span>
                      <a href="mailto:ayushmishra7352@gmail.com">
                        <i className="fal fa-envelope-open-text"></i>
                      </a>
                    </span>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm">Email Me</h4>
                    <span>
                      <a href="mailto:ayushmishra7352@gmail.com">
                        ayushmishra7352@
                        <br />
                        gmail.com
                      </a>
                    </span>
                  </div>
                </div>
                <div
                  className="contact__item d-flex align-items-center wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <div className="contact__icon">
                    <span>
                      <a
                        href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-linkedin"></i>
                      </a>
                    </span>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm">Connect on LinkedIn</h4>
                    <span>
                      <a
                        href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Professional Profile
                      </a>
                    </span>
                  </div>
                </div>

                {/* Response Time Info */}
                <div
                  className="contact__response-info wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                  style={{
                    background: "rgba(255, 220, 96, 0.1)",
                    border: "1px solid #FFDC60",
                    borderRadius: "10px",
                    padding: "20px",
                    marginTop: "30px",
                    textAlign: "center",
                  }}
                >
                  <h5
                    style={{
                      color: "#FFDC60",
                      marginBottom: "10px",
                      fontSize: "16px",
                    }}
                  >
                    ⚡ Quick Response Promise
                  </h5>
                  <p style={{ fontSize: "14px", margin: "0", color: "#666" }}>
                    I respond to all project inquiries within 2-4 hours during
                    business hours. For urgent discussions, call or WhatsApp me
                    directly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactTwo;
